module.exports = function() {
    var $hero = $('.hero-with-image-and-links');
    if ($hero.length) {
        var $calloutContainer = $hero.find('.hero-with-image-and-links-callout-container').first();
        if ($calloutContainer.length) {
            var update = function() {
                var scrollThreshold = $hero.offset().top + $hero.find('.hero-with-image-and-links-container').outerHeight();
                var scrollPosition = $(window).scrollTop();

                if (scrollThreshold <= scrollPosition) {
                    $hero.addClass('hero-with-image-and-links-sticky');
                } else {
                    $hero.removeClass('hero-with-image-and-links-sticky');
                }
            };

            setInterval(update, 20);
        }
    }
};